import { combineReducers } from "@reduxjs/toolkit";
import { animefurusatoReducer } from "modules/pages/lp/animefurusato";

export const lpReducer = combineReducers({
  animefurusato: animefurusatoReducer,
});
